import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';

/**
 * Generischer Confirm-Dialog für reversible / niedrig-riskante Actions.
 * Destruktive String-Confirm-Aktionen: siehe `<ConfirmStringDialog>`.
 */
export function ConfirmDialog({
  isOpen,
  title,
  body,
  confirmLabel = 'Bestätigen',
  confirmColor = 'primary',
  cancelLabel = 'Abbrechen',
  busy = false,
  onConfirm,
  onCancel,
}) {
  return (
    <Modal isOpen={isOpen} toggle={busy ? undefined : onCancel} backdrop={busy ? 'static' : true}>
      <ModalHeader toggle={busy ? undefined : onCancel}>{title}</ModalHeader>
      <ModalBody>{body}</ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={onCancel} disabled={busy}>
          {cancelLabel}
        </Button>
        <Button color={confirmColor} onClick={onConfirm} disabled={busy}>
          {busy ? 'Bitte warten…' : confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
